<template>
  <Wrapper class="app app--auth">
    <div class="app-content">
      <div class="block block-shadow py-30 block-rounded">
        <header class="block-header text-center" v-if="isDefaultLogo != ''">
          <img :src="isDefaultLogo" alt="brand logo" />
        </header>
        <div>
          <div class="block-content py-0">
            <h1 class="block-title text-center">
              {{ pageTitle }}
            </h1>
            <p v-if="pageSubtitle" class="text-center">
              {{ pageSubtitle }}
            </p>
          </div>
          <div v-if="errors.length" class="block-content">
            <div
              v-for="(error, index) in errors"
              class="alert alert-danger"
              :key="index"
            >
              {{ error.message }}
            </div>
          </div>
          <div v-if="info" class="block-content">
            <div class="alert alert-info">{{ info }}</div>
          </div>
          <div v-if="showForm" class="block-content">
            <form class="form" @submit.prevent="handleFormSubmit">
              <div class="form-group mb-30">
                <div class="form-material pt-0">
                  <input
                    type="text"
                    v-model="email"
                    name="email"
                    placeholder="Email"
                    class="form-control no-focus"
                    v-validate="'required|email|isEmailExist'"
                    data-vv-as="email"
                  />
                  <div v-if="veeErrors.first('email')" class="invalid-feedback">
                    {{ veeErrors.first("email") }}
                  </div>
                  <label for="email" class="sr-only">Email</label>
                </div>
              </div>
              <div class="form-group">
                <button
                  type="submit"
                  class="btn btn-gd btn-gd-primary btn-block"
                  style="color: #fff"
                  :disabled="isLoading"
                >
                  <Spinner v-if="isLoading" theme="currentColor" />
                  <span v-else>Send</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Wrapper>
</template>

<script>
import axiox from "@/helpers/base";
import Wrapper from "./Wrapper";
import Spinner from "@/components/Spinner";
import { forgotPasswordMailer } from "@/helpers/mailer";
import crypto from "crypto";
import _ from "lodash";
import { Validator } from "vee-validate";
import axios from "@/helpers/axios";

export default {
  components: {
    Wrapper,
    Spinner
  },
  data() {
    return {
      isLoading: false,
      pageTitle: "Reset Password",
      pageSubtitle:
        "Please enter your email address to request a password reset link.",
      errors: [],
      info: "",
      email: null,
      showForm: true,
      isDefaultLogo: "",
      headroomLogo: require("@/assets/media/brand.svg")
    };
  },
  created() {
    const isEmailExist = email =>
      axios
        .get(`/users?email=${email}&paranoid=false`)
        .then(res => res.data.data)
        .then(data => {
          if (data) return { valid: true };
          return {
            valid: false,
            data: { message: "Email address is not registered." }
          };
        });

    Validator.extend("isEmailExist", {
      validate: isEmailExist,
      getMessage: (field, params, data) => data.message
    });
  },
  async mounted() {
    await this.$store.dispatch("fetchOptions");

    let defaultLogoStatus = _.filter(this.options, ["key", "defaultlogo.main"]);
    if (
      defaultLogoStatus.length &&
      defaultLogoStatus[0].value.status == false
    ) {
      let defaultLogo = _.filter(this.options, ["key", "defaultlogo.sub"]);
      if (defaultLogo.length && defaultLogo[0].value.image) {
        this.isDefaultLogo = defaultLogo[0].value.image;
      } else {
        this.isDefaultLogo = this.headroomLogo;
      }
    } else {
      this.isDefaultLogo = this.headroomLogo;
    }
  },
  computed: {
    options() {
      return this.$store.state.concierge.optionsList.data;
    }
  },
  methods: {
    async handleFormSubmit() {
      this.isLoading = true;
      this.info = "";
      this.errors = [];

      try {
        const token = crypto.randomBytes(16).toString("hex");
        let isFormValid = await this.$validator.validateAll();

        if (!isFormValid) {
          throw Error("Please fix all errors.");
        }

        const {
          status,
          data: { data }
        } = await axiox.post("/auth/forgot", {
          email: this.email,
          token
        });

        if (status !== 200) {
          throw new Error("Unable to process request");
        }

        await forgotPasswordMailer({
          name: data.firstName,
          to: this.email,
          resetTokenUrl: `${location.origin}/reset?token=${token}`
        });

        this.email = null;
        this.pageSubtitle = null;
        this.info =
          "Follow the directions in the email to reset your password.";
        this.pageTitle = "Password Reset Email Sent!";
        this.showForm = false;
      } catch (error) {
        if (error.response) {
          return (this.errors = error.response.data.errors);
        }

        this.$toastr.error(error.message, "Oops!");
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
